"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultRedirectUri = exports.maxDomainPerOauth = exports.minSecretLength = exports.maxSecretLength = exports.logMessageKeys = void 0;
exports.logMessageKeys = {
    startExecuteDriver: "driver.apiKey.log.startExecuteDriver",
    failedExecuteDriver: "driver.apiKey.log.failedExecuteDriver",
    skipCreateOauth: "driver.oauth.log.skipCreateOauth",
    oauthNotFound: "driver.oauth.log.oauthNotFound",
    successCreateOauth: "driver.oauth.log.successCreateOauth",
    skipUpdateOauth: "driver.oauth.log.skipUpdateOauth",
    successUpdateOauth: "driver.oauth.log.successUpdateOauth",
    microsoftEntraWarning: "driver.oauth.microsoftEntraWarning",
};
exports.maxSecretLength = 512;
exports.minSecretLength = 10;
exports.maxDomainPerOauth = 1;
exports.defaultRedirectUri = "https://teams.microsoft.com/api/platform/v1.0/oAuthConsentRedirect";
//# sourceMappingURL=constants.js.map